import useNotification from "component/global/event-handler/hooks/use-notification";
import { useRef } from "react";
import { evaluateReferenceFilterTemplate } from "modules/record/shared/services/evaluateReferenceFilter";

export const useEvaluateReferenceFilter = () => {
    const notify = useNotification();
    const lastErrorKeyRef = useRef<string | null>(null);

    const evaluateReferenceFilter = (
        referenceFilter: string,
        values: Record<string, any>
    ): Record<string, any> | undefined => {
        if (!referenceFilter) {
            return undefined;
        }

        try {
            const queries = evaluateReferenceFilterTemplate(referenceFilter, values);
            lastErrorKeyRef.current = null;

            return queries;
        } catch (error) {
            const errorKey = `${referenceFilter}::${JSON.stringify(values)}`;
            console.error("[REFERENCE_FILTER_ERROR]", {
                filter: referenceFilter,
                values,
                error
            });

            if (lastErrorKeyRef.current !== errorKey) {
                notify.alert(
                    "ON-APPLY-REFERENCE_FILTER-ERROR",
                    "It was not possible to apply filter in this search. Please review your system configuration."
                );
                lastErrorKeyRef.current = errorKey;
            }

            return undefined;
        }
    };

    return { evaluateReferenceFilter };
};
